import './ImagePreview.scss';

export { default } from './ImagePreview';
